module.exports = __webpack_public_path__ + "img/dark-logo.4a944286.svg";